module.exports = __webpack_public_path__ + "static/assets/d3b8a4151551c60da8dee1931d0806fd.png";